import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, Fragment as _Fragment, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-90bc5eac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dot-menu" }
const _hoisted_2 = ["aria-expanded", "onClick"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "4",
  height: "16",
  viewBox: "0 0 4 16",
  fill: "currentColor",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "2",
    cy: "2",
    r: "1.7"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "2",
    cy: "8",
    r: "1.7"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "2",
    cy: "14",
    r: "1.7"
  })
], -1))
const _hoisted_4 = [
  _hoisted_3
]

import { ref, nextTick } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DotMenu',
  setup(__props) {

const open = ref(false);
const trigger = ref<HTMLElement | null>(null);
const panelStyle = ref<Record<string, string>>({});
const PANEL_WIDTH = 190;

async function toggle() {
  if (open.value) {
    open.value = false;
    return;
  }
  open.value = true;
  await nextTick();
  const el = trigger.value;
  if (!el) return;
  const r = el.getBoundingClientRect();
  const left = Math.max(8, Math.min(r.right - PANEL_WIDTH, window.innerWidth - PANEL_WIDTH - 8));
  panelStyle.value = { top: `${Math.round(r.bottom + 4)}px`, left: `${Math.round(left)}px` };
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createElementVNode("button", {
      ref_key: "trigger",
      ref: trigger,
      type: "button",
      class: "dot-menu-btn",
      title: "Aktionen",
      "aria-expanded": open.value,
      onClick: _withModifiers(toggle, ["stop"])
    }, _hoisted_4, 8, _hoisted_2),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (open.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", {
              class: "dot-menu-backdrop",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (open.value = false))
            }),
            _createElementVNode("div", {
              class: "dot-menu-panel",
              style: _normalizeStyle(panelStyle.value),
              role: "menu",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (open.value = false))
            }, [
              _renderSlot(_ctx.$slots, "default")
            ], 4)
          ], 64))
        : _createCommentVNode("", true)
    ]))
  ]))
}
}

})